export const SUFFIXES = ["Jr.", "Sr.", "2nd", "3rd"];

export const SUFFIXES_OPTIONS = SUFFIXES.map((item) => ({
    label: item,
    value: item,
}));


